/**
 * The injectable service type names
 */
export const TYPES = {
	AjaxService: "AjaxService",
	ClientContext: "ClientContext",
	FormComponentService: "FormComponentService",
	FormService: "FormService",
	DataGridService: "DataGridService",
	IpfModule: "IpfModule",
	LoaderService: "LoaderService",
	MessageService: "MessageService",
	PageService: "PageService",
	ScriptService: "ScriptService",
	SearchFilterService: "SearchFilterService",
	SessionValidationService: "SessionValidationService",
	TierSelectorService: "TierSelectorService",
	UrlService: "UrlService",
	UserTierService: "UserTierService",
	ValidationService: "ValidationService",
	WizardService: "WizardService"
};
